<template>
  <Modal @close="close" :active="active" title="Cadastrar-se">
    <form class="modal-register" @submit.prevent="submit()" ref="form">
      <Input
        :value="name"
        @change="event => name = event"
        :disabled="sending"
        :invalid="$v.name.$invalid"
        placeholder="Nome"
        label="Nome completo"
      />
      <Input
        :value="phone"
        @change="event => phone = event"
        :disabled="sending"
        :invalid="$v.phone.$invalid"
        v-mask="'(##) # ####-####'"
        placeholder="(99) 9 9999-9999"
        label="Telefone"
      />
      <Input
        :value="email"
        @change="event => email = event"
        :disabled="sending"
        :invalid="$v.email.$invalid"
        placeholder="E-mail"
        label="E-mail"
      />
      <Input
        :value="password"
        @change="event => password = event"
        type="password"
        :disabled="sending"
        :invalid="$v.password.$invalid"
        placeholder="Senha"
        label="Senha"
      />
      <Input
        :value="repassword"
        @change="event => repassword = event"
        type="password"
        :disabled="sending"
        :invalid="$v.repassword.$invalid"
        placeholder="Repita sua senha"
        label="Repita sua senha"
      />
      <Alert
        v-for="(notification, index) in notifications"
        :key="index"
        :title="notification.title"
        :icon="notification.icon"
        :type="notification.type"
      />
      <Button
        @click="submit"
        :disabled="sending"
        :loading="sending"
        type="primary"
        title="Cadastrar-se"
      />
    </form>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '../../services/api'
import { mask } from 'vue-the-mask'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
import common from '../../mixins/common'

import Modal from '../Modal'
import Input from '../Input'
import Button from '../Button'
import Alert from '../Alert'

export default {
  name: 'ModalRegister',
  components: {
    Modal,
    Input,
    Button,
    Alert
  },
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      password: '',
      repassword: '',
      sending: false,
      notifications: []
    }
  },
  mixins: [common],
  computed: {
    ...mapGetters(['getUserFb', 'getXtoken'])
  },
  directives: { mask },
  validations: {
    name: { required, minLength: minLength(4) },
    email: { required, email },
    phone: { required },
    password: { required, minLength: minLength(4) },
    repassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(['clearAlert', 'addAlert']),
    close (event = false) {
      this.notifications = []
      this.$refs.form.reset()
      this.$emit('close', event)
    },
    async submit () {
      this.clearAlert()
      this.notifications = []
      if (this.sending) {
        return
      }
      this.sending = true
      if (this.$v.$invalid) {
        this.notifications.push({
          type: 'danger',
          icon: 'alert-rhombus-outline',
          title: 'Por favor, verifique seus dados.'
        })
        this.sending = false
        return
      }
      try {
        const params = {}

        params.client_type = this.clientType
        params.establishment_id = this.establishmentId
        params.name = this.name
        params.phone = this.phone.replace(/[^0-9]/g, '')
        params.email = this.email
        params.password = this.password
        params.xtoken = JSON.parse(this.getXtoken)
        if (this.getUserFb !== null && typeof this.getUserFb === 'object') {
          params.fbid = this.getUserFb.id
        }

        const response = await api.post('/users?return_token=true', params)
        if (response.data.token) {
          const newAlert = {
            type: 'success',
            icon: 'checkbox-marked-circle-outline',
            title: 'Cadastrado com sucesso!'
          }
          this.addAlert(newAlert)
          this.notifications.push(newAlert)
          this.redirect(response.data.token)
        }
      } catch (error) {
        switch (error.response.data.message) {
          case 'user_already_exist': {
            this.notifications.push({
              type: 'danger',
              icon: 'alert-rhombus-outline',
              title: 'E-mail informado esta sendo utilizado por outro usuário.'
            })
            break
          }
          case '\"first_name\" length must be less than or equal to 15 characters long': {
            this.notifications.push({
              type: 'danger',
              icon: 'alert-rhombus-outline',
              title: 'O campo "Nome" não pode conter mais de 15 caracteres'
            })
            break
          }
          case '\"last_name\" length must be less than or equal to 35 characters long': {
            this.notifications.push({
              type: 'danger',
              icon: 'alert-rhombus-outline',
              title: 'O campo "Sobrenome" não pode conter mais de 35 caracteres'
            })
            break
          }
          case 'invalid_email': {
            this.notifications.push({
              type: 'danger',
              icon: 'alert-rhombus-outline',
              title:
                'Por favor, verifique se seu e-mail é válido e também se existe.'
            })
            break
          }
          default:
            this.notifications.push({
              type: 'danger',
              icon: 'alert-rhombus-outline',
              title:
                'Houve algum problema no cadastro. Por favor, verifique seus dados e tente novamente.'
            })
            break
        }
      }
      this.sending = false
    },
    completeUserData () {
      if (this.getUserFb !== null && typeof this.getUserFb === 'object') {
        this.name = this.getUserFb.name
        this.email = this.getUserFb.email
        this.phone = this.getUserFb.phone
      }
    }
  },
  mounted () {
    this.completeUserData()
  },
  watch: {
    getUserFb () {
      this.completeUserData()
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
